import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './cola.png'


const _withScopeId = n => (_pushScopeId("data-v-f656ac3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-campaign-cocacola-season-4" }
const _hoisted_2 = { class: "apply-view" }
const _hoisted_3 = { class: "apply-view-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-cocacola d-none d-md-block",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "apply-title" }, " 제로 웨이스트 박스 수거하기 ", -1))
const _hoisted_6 = {
  key: 0,
  class: "step step-1"
}
const _hoisted_7 = { class: "step-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, " 꼭 확인해주세요! ", -1))
const _hoisted_9 = { class: "desc" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 리워드는 일부만 받을 수 없으니, ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<p class=\"desc\" data-v-f656ac3c> 투명 음료 페트병 이외의 물품을 보내 주실 경우 <br class=\"d-block d-md-none\" data-v-f656ac3c>리워드가 제공되지 않습니다. </p><p class=\"desc\" data-v-f656ac3c> 리워드는 여러분이 보내 주신 제로 웨이스트 박스 검수 후<br class=\"d-block d-md-none\" data-v-f656ac3c> 순차적으로 발송돼요. <br data-v-f656ac3c>테라사이클 팀이 하나하나 모두 확인하기 때문에 <br class=\"d-block d-md-none\" data-v-f656ac3c>7~20일까지 시간이 소요될 수 있어요. </p>", 2)
const _hoisted_14 = { class: "box-buttons" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 취소 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 확인했어요 ")
const _hoisted_17 = {
  key: 1,
  class: "step step-2"
}
const _hoisted_18 = { class: "step-box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, [
  /*#__PURE__*/_createTextVNode(" 원더플 피플! 몇 개의 박스를"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 수거 신청하시겠어요? ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 박스 수량에 따라 택배 송장이 발행되니 반드시 수량을"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 체크해주세요! ")
], -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "box-buttons" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 취소 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 수거 신청 ")
const _hoisted_25 = {
  key: 2,
  class: "step step-3"
}
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"step-box\" data-v-f656ac3c><div class=\"step-title\" data-v-f656ac3c> 고마워요 원더플 피플! <br data-v-f656ac3c>수거 신청이 완료됐어요. </div><p class=\"desc\" data-v-f656ac3c> 한진택배 기사님이 3~4일 내 &lt;반품 택배&gt;로<br class=\"d-block d-md-none\" data-v-f656ac3c> 픽업할 예정이에요. </p><p class=\"desc\" data-v-f656ac3c> 박스는 테이프로 밀봉한 뒤 현관문 앞에 두시면 돼요. </p><p class=\"desc\" data-v-f656ac3c> 리워드는 여러분이 보내 주신 제로 웨이스트 박스 검수 후 <br class=\"d-block d-md-none\" data-v-f656ac3c>순차적으로 발송돼요. </p><br class=\"d-block d-md-none\" data-v-f656ac3c><div class=\"tip\" data-v-f656ac3c> 테라사이클 팀이 하나하나 모두 확인하기 때문에 입고되는 <br class=\"d-block d-md-none\" data-v-f656ac3c>박스 물량에 따라 7~20일까지 시간이 소요될 수 있어요. </div></div>", 1)
const _hoisted_27 = { class: "box-buttons" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 확인 ")

import { IProgram } from '@/types/program';
import { ref, onMounted, onUnmounted, reactive, inject, nextTick } from 'vue';
import Page1 from './components/page-1/index.vue';
import Navbar from './components/navbar.vue';
import Page2 from './components/page-2/index.vue';
import Page3 from './components/page-3/index.vue';
import Page4 from './components/page-4/index.vue';
import Page5 from './components/page-5/index.vue';
import Page6 from './components/page-6/index.vue';
import Page7 from './components/page-7/index.vue';
import Page8 from './components/page-8/index.vue';
import Page9 from './components/page-9/index.vue';
import Faq from './components/faq/index.vue';
import Footer from './components/footer/index.vue';
import CampaignCheck, { Expose as CampaignCheckExpose } from '@/components/campaign/check.vue';
import CampaignApply, { Expose as CampaignApplyExpose } from '@/components/campaign/apply.vue';
import { ColorVariants } from '@/constants';
import _ from 'lodash';
import DialogSelectChallenge from './components/dialog-select-challenge/index.vue';
import PopupNotice from './components/popup-notice/index.vue';
import './dialog.scss';

interface IProps {
  program: IProgram;
}interface Info {
  title: string;
  content: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) }
  },
  setup(__props: any) {

const props = __props as { program: IProgram }

;



const currentApplyStep = ref(0);
function navToStep2() {
  currentApplyStep.value = 2;
}

const getFormDeDefaultData = () => ({
  request_times: 0,
  collection_challenge: 0,
});
const form = reactive(getFormDeDefaultData());
function setBoxValue(val: number) {
  form.request_times = val;
}

function onChallengeSelect() {
  if (String(props.program.collection_challenge) !== String(form.collection_challenge)) {
    showInfoDialog({
      title: '',
      content: '참여 중인 챌린지 유형을 다시 확인해주세요.'
    });
    return;
  }
  closeDialog();
  currentApplyStep.value = 1;
}

const applyRef = ref<CampaignApplyExpose>();
async function requestApply() {
  await applyRef.value?.apply({ request_times: form.request_times });
}
async function onRequestApplySuccess() {
  currentApplyStep.value = 3;
}

function cancelApply() {
  currentApplyStep.value = 0;
  // 重置表单
  Object.assign(form, getFormDeDefaultData());
}

const checkRef = ref<CampaignCheckExpose>();
const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
async function onRequestCollection() {
  const valid = await checkRef.value?.check();
  if (valid) {
    await refreshPageData();
    await nextTick();

    const { show_collection_btn, collection_btn_msg, collection_challenge = 0, collection_count } = props.program;

    if (show_collection_btn) {
      // 超过了提交次数
      if (collection_count >= collection_challenge) {
        showInfoDialog({
          title: '',
          content: `수령하신 제로 웨이스트 박스
  모두 수거 신청 완료되었습니다.`
        });
        return;
      }

      showDialog('collection_challenge');
      return;
    }
    showInfoDialog({
      title: '',
      content: collection_btn_msg!,
    });
  }
}

const dialog = reactive({
  info: false,
  collection_challenge: false,
});

const infoDialogProps = ref<Info>();
function showInfoDialog(info: Info) {
  infoDialogProps.value = info;
  showDialog('info');
}
function showDialog(dialogName: keyof typeof dialog) {
  closeDialog();
  dialog[dialogName] = true;
}
function closeDialog(dialogName?: keyof typeof dialog) {
  if (dialogName) {
    dialog[dialogName] = false;
  } else {
    _.forEach(dialog, (val, key) => {
      if (val) {
        dialog[key] = false;
      }
    });
  }
}

const bodyClass = 'body-campaign-cocacola-season-4';
onMounted(() => document.body.classList.add(bodyClass));
onUnmounted(() => document.body.classList.remove(bodyClass));

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PopupNotice),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Page1, {
        program: __props.program,
        onRequestCollection: onRequestCollection
      }, null, 8, ["program"]),
      _createVNode(Navbar),
      _createVNode(Page2),
      _createVNode(Page3),
      _createVNode(Page4),
      _createVNode(Page5, { program: __props.program }, null, 8, ["program"]),
      _createVNode(Page6),
      _createVNode(Page7),
      _createVNode(Page8, { onRequestCollection: onRequestCollection }),
      _createVNode(Page9),
      _createVNode(Faq),
      _createVNode(Footer)
    ], 512), [
      [_vShow, !currentApplyStep.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(CampaignCheck, {
          ref_key: "checkRef",
          ref: checkRef,
          "class-name": "dialog-campaign-cocacola-s4"
        }, null, 512),
        _createVNode(CampaignApply, {
          ref_key: "applyRef",
          ref: applyRef,
          "class-name": "dialog-campaign-cocacola-s4",
          program: __props.program,
          "on-success": onRequestApplySuccess
        }, null, 8, ["program"]),
        _createVNode(_component_AppDialog, _mergeProps({
          visible: _unref(dialog).info,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).info) = $event)),
          class: "dialog-campaign-cocacola-s4"
        }, infoDialogProps.value, {
          btns: [
            { text: '확인', style: _unref(ColorVariants).primary, click: () => closeDialog() }
          ]
        }), null, 16, ["visible", "btns"]),
        _createVNode(DialogSelectChallenge, {
          modelValue: _unref(form).collection_challenge,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).collection_challenge) = $event)),
          visible: _unref(dialog).collection_challenge,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).collection_challenge) = $event)),
          "button-disabled": !_unref(form).collection_challenge,
          "is-collection": "",
          onButtonClick: onChallengeSelect
        }, null, 8, ["modelValue", "visible", "button-disabled"])
      ])),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (currentApplyStep.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _createTextVNode(_toDisplayString(__props.program.collection_challenge) + "개 박스 모두 정해진 수거 기간 내 보내주세요. ", 1)
                ]),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_b_button, {
                  class: "button button-dark",
                  onClick: cancelApply
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_button, {
                  class: "button button-primary",
                  onClick: navToStep2
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (currentApplyStep.value === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _createElementVNode("div", {
                  class: _normalizeClass(["choose-boxes", { 'two-in-row': Number(__props.program.collection_challenge) > 2 }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Number(__props.program.collection_challenge), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["box", { active: _unref(form).request_times === index + 1, disabled: index + 1 > (__props.program.remaining_collection_times || 0) }]),
                      onClick: ($event: any) => (setBoxValue(index + 1))
                    }, _toDisplayString(index + 1) + "박스 수거 ", 11, _hoisted_21))
                  }), 128))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_b_button, {
                  class: "button button-dark",
                  onClick: cancelApply
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_button, {
                  class: "button button-primary",
                  disabled: !_unref(form).request_times,
                  onClick: requestApply
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (currentApplyStep.value === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_b_button, {
                  class: "button button-primary",
                  onClick: cancelApply
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, currentApplyStep.value]
    ])
  ]))
}
}

})